export default {
  country: 'PE',
  label: 'Departamento/Región',
  items: [
    { code: 'AMA', name: 'Amazonas' },
    { code: 'ANC', name: 'Áncash' },
    { code: 'APU', name: 'Apurímac' },
    { code: 'ARE', name: 'Arequipa' },
    { code: 'AYA', name: 'Ayacucho' },
    { code: 'CAJ', name: 'Cajamarca' },
    { code: 'CAL', name: 'Callao' },
    { code: 'CUS', name: 'Cusco' },
    { code: 'HUV', name: 'Huancavelica' },
    { code: 'HUC', name: 'Huánuco' },
    { code: 'ICA', name: 'Ica' },
    { code: 'JUN', name: 'Junín' },
    { code: 'LAL', name: 'La Libertad' },
    { code: 'LAM', name: 'Lambayeque' },
    { code: 'LIM', name: 'Lima' },
    { code: 'LOR', name: 'Loreto' },
    { code: 'MDD', name: 'Madre de Dios' },
    { code: 'MOQ', name: 'Moquegua' },
    { code: 'PAS', name: 'Pasco' },
    { code: 'PIU', name: 'Piura' },
    { code: 'PUN', name: 'Puno' },
    { code: 'SAM', name: 'San Martín' },
    { code: 'TAC', name: 'Tacna' },
    { code: 'TUM', name: 'Tumbes' },
    { code: 'UCA', name: 'Ucayali' }
  ]
}
